import * as React from 'react';

interface IProps {
    className?: string;
    onClick?: any;
}

class IconSocialTwitter extends React.Component<IProps> {
    public render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" className={this.props.className} onClick={this.props.onClick} viewBox="0 0 24 24" height="24" width="24">
                <desc>
                    Twitter X Streamline Icon: https://streamlinehq.com
                </desc>
                <path d="M18.9 1.125h3.681l-8.040000000000001 9.213000000000001L24 22.875h-7.4055l-5.8004999999999995 -7.605 -6.637499999999999 7.605H0.474l8.599499999999999 -9.855L0 1.125h7.5945l5.2425 6.9495000000000005L18.901500000000002 1.125Zm-1.29 19.542h2.04L6.484500000000001 3.2175000000000002H4.2975z" strokeWidth="1.5" />
            </svg>
        );
    }
}

export default IconSocialTwitter;
